import { Record } from "immutable";

const defaults = {
    allowed_values: [],
    default_value: "",
    formatters: [],
    lookup: "",
    subtype: "",
    type: "",
    validators: [],
    value_dependency: "",
    condition: undefined,
};

export class Details extends Record(defaults) {
    declare type: string;
    declare subtype: string;
    declare default_value: string;
    declare lookup: string;
    declare validators: string[];
    declare formatters: string[];
    declare value_dependency: string;
    declare allowed_values: Array<{ value: string }>;
    declare condition: any;

    constructor(args: any = {}) {
        super({
            ...args,
        });
    }
}
